<template>
  <div class="header">
    <h1><img src="../assets/img/logo2.png" style="width:100px"/><img src="../assets/img/logo.png" /><p>慧营销</p></h1>
    <div class="right">
    <Form ref="form" :btnText="btnText" :channel="channel"></Form>
    <div class="product " @click="openProduct()"></div>
    <div class="popup container">
      <mt-popup 
        v-model="popupVisible"
        modal="false"
        position="right">
        <Menu :list="menu"/>
      </mt-popup>
    </div> 
    </div>
    <!-- <a href="tel:18958188698" class="dPhone"></a> -->
  </div>
</template>
<script>
import Text from '../utils/text'
import Menu from './Menu'
import Form from './Form'
export default {
  name:'Header',
  components:{
    Menu,
    Form
  },
  data(){
    return {
      menu:[],
      popupVisible:false,
      scrollTop:0,
      currentReady:false,
      channel:false,
      btnText:'开通申请'
    }
  },
  watch:{
    popupVisible:{
      handler(old,aa){
        this.toggleBody(old)
      },
      deep:true
    },
    $route: {
      handler: function(val, oldVal){
        window.scrollTo(0,0);
        this.currentReady = true
        if(val.name == 'BusAgent'){
          this.channel = true
          this.btnText ='申请加盟'
        }else{
          this.channel = false
          this.btnText ='开通申请'
        }
        this.$refs.form.checkChannel()
      },
      // 深度观察监听
      deep: true
    }
  },
  created(){
    this.menu = Text.websiteText['menu']
    if(this.$route.name == 'BusAgent'){
      this.channel = true
      this.btnText = '申请加盟'
    }
  },
  mounted(){
    const that = this
    this.bus.$on('closemenu',function(){
      that.popupVisible = false
    })
  },
  methods:{
    openProduct(){
      if(!this.popupVisible){
        const scrollTop = document.scrollingElement.scrollTop;
        this.scrollTop = scrollTop
        document.body.style.top = -this.scrollTop + 'px'
      }
      this.currentReady = false
      this.popupVisible =  this.popupVisible?false:true
    },
    toggleBody(isPin){
      if(isPin){
        document.body.className = 'scrollTop'
      }
      else{
        document.body.className = ''
        document.body.style.top = 0
        if(!this.currentReady){
          window.scrollTo(0,this.scrollTop);
        }
      }
    },
    getScrollTop(){
      const scrollTop = document.scrollingElement.scrollTop;
      this.scrollTop = scrollTop
    }
  }
}
</script>

<style lang="scss">
  .header{
    position: fixed;
    top:0;left:0;
    background:#fff;  
    padding:0 20px;
    width:100%;
    height:90px;
    @include flex($just:space-between,$align:center);
    box-sizing: border-box;
    z-index:100;
    .right{
       @include flex($just:space-between,$align:center);
    }
    p{
      font-size:28px;
    }
    h1{
      vertical-align:middle;
       @include flex($just:space-between,$align:center);
    }
    img{
      // display: inline-block;
      margin-right:10px;
      width:50px;
      height:50px;
    }
    .product{
      margin-left:37px;
      display: block;
      width:36px;
      height:36px;
      background:url('../assets/img/p-icon.png') no-repeat;
      background-size: cover;
    }
    .popup{
      position: relative;
      // top:0;left:0;
      // height:100%;
      z-index:200;
      .v-modal{
        top:90px;
        z-index:200;
      }
      .mint-popup{
        margin-top:89px;
        width:80%;
        height:100%;
        top:50%;
        background:#eaeef7;
      }
    }
  }
  body.scrollTop{
    position:fixed;
    left:0;
    // height:100vh;
    // height:100%;
    overflow:hidden
  }
  .dPhone{
    position: fixed;
    bottom:100px;
    right:20px;
    display: block;
    width:100px;
    height:100px;
    background:url('../assets/img/phone.png') no-repeat;
    background-size:contain;
  }


</style>
